// Core
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Packages
import { Layout as LayoutAndtD } from 'antd';

// Layout config
import { BACKGROUND_NEUTRAL } from '../config/Layout';
import { getAppTheme } from '../store/app/getters';

const Layout = (props) => {
  const { appThemeSlug, children } = props;

  // Layout style
  const style = {
    minHeight: '100vh',
    background: BACKGROUND_NEUTRAL[appThemeSlug],
  };

  return <LayoutAndtD style={style}>{children}</LayoutAndtD>;
};

// Prop types
Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  appThemeSlug: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  appThemeSlug: getAppTheme(state, 'slug'),
});

export default connect(mapStateToProps)(Layout);
